<template>
  <div class="task-assign-component">
    <el-dialog :title="$t('taskCenter.title.assignTasks')"
               :visible.sync="taskReViewStatus"
               v-dialogDrag
               top="20px"
               @close="close"
               width="900px">
      <div class="wholePage">
        <ioc-form :option="option"
                  v-model="taskInfo"
                  ref="ruleForm"></ioc-form>
        <div class="page-bottom"
             style="height:46px;clear:both;overflow:hidden;margin-top: -30px;">
          <el-form :model="taskInfo"
                   ref="taskArea">
            <el-form-item :label="$t('taskCenter.label.areaDevGroupName')"
                          label-width="140px"
                          class="is-required">
              <div class="fl"
                   style="width:200px">
                <el-input disabled
                          v-model="taskInfo.areaDevGroupName"></el-input>
              </div>
              <div class="fl pl10 pointer">
                <a @click="openAreaTree">{{$t('taskCenter.title.choose')}}</a>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- 设备告警 -->
        <div class="equipmentAlarm"
             v-show="isEquipmentAlarm">
          <el-form :model="equipmentAlarmForm"
                   :rules="equipmentAlarmRules"
                   ref="equipmentAlarmForm">
            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('taskCenter.label.deviceName')"
                              label-width="140px"
                              prop="deviceName">
                  <el-input style="width: 100%;"
                            v-model="equipmentAlarmForm.deviceName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10"
                      :offset="1">
                <el-form-item :label="$t('taskCenter.label.alarmDetailLevel')"
                              label-width="100px"
                              prop="alarmLevel">
                  <el-select v-model="equipmentAlarmForm.alarmLevel"
                             style="width: 90%;">
                    <el-option v-for="(item, index) in alarmLevelOption"
                               :key="index"
                               :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item :label="$t('taskCenter.label.alarmDetailType')"
                            label-width="140px"
                            prop="subSystem"
                            class="fl">
                <el-select v-model="equipmentAlarmForm.subSystem"
                           style="width: 200px;"
                           @change="subSystemChange">
                  <el-option v-for="item in equipmentTypeOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="alarmType"
                            class="fl">
                <el-select v-model="equipmentAlarmForm.alarmType"
                           style=" width: 215px;margin-left: 133px">
                  <el-option v-for="item in alarmTypeOption"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item :label="$t('taskCenter.label.alarmTime')"
                            prop="alarmTimeProp"
                            label-width="140px">
                <el-date-picker style="width: 81%;"
                                v-model="equipmentAlarmForm.alarmTimeProp"
                                type="datetime"
                                value-format="timestamp"></el-date-picker>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <!-- 执行人员 -->
        <div class="page-bottom">
          <el-form ref="assignTaskForm">
            <el-form-item :label="$t('taskCenter.label.doPersons')"
                          label-width="140px"
                          prop="executors"
                          :rules="{required: true, message: this.$t('taskCenter.message.choosePerson'), trigger: 'blur'}">
              <el-radio v-model="taskInfo.userFrom"
                        label="0"
                        @change="checkByGroup">{{$t('taskCenter.label.groupChoice')}}</el-radio>
              <el-radio v-model="taskInfo.userFrom"
                        label="1">{{$t('taskCenter.label.mapChoice')}}</el-radio>
            </el-form-item>
            <el-form-item label
                          label-width="140px">
              <!-- 选择账户组 -->
              <div style="height: 180px;"
                   v-show="taskInfo.userFrom == '0'">
                <!-- <app-account-group ref="appAcountGroup"
                                   :subTaskInfoList="subTaskInfoList"></app-account-group> -->
                <work-group-tree ref="workGroupTree"
                                 :multiCheck="true"
                                 class="workGP"
                                 style="height:150px !important"
                                 @groupData="getGroupData"
                                 :showPercentage="false"></work-group-tree>
              </div>
              <!-- 用地图选择人员 -->
              <div class="clearfix fl panel p5 m5"
                   v-if="taskInfo.userFrom == '1'">
                <template v-for="(item, index) in accoutInfo">
                  <div class="user-item"
                       :key="index">
                    <div class="user-item-txt"
                         :title="item.executor">{{item.executor}}</div>
                    <div class="user-item-delete el-icon-delete pointer"
                         @click="deleteAccount(index)"></div>
                    <div class="clear"></div>
                  </div>
                </template>
                <!-- 触发地图弹窗 -->
                <div class="selectPerson"
                     @click="checkByMap">
                  {{$t('taskCenter.label.mapChoices')}}
                  <div class="iconfont icon-expand expand"></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('taskCenter.label.taskDesc')"
                          label-width="140px"
                          class="task-desc">
              <div class="task-desc-limit">
                <el-input type="textarea"
                          :rows="4"
                          :placeholder="$t('taskCenter.placeholder.enterContent')"
                          v-model="taskInfo.desc"></el-input>
                <p class="span">
                  <span>{{taskDescTotal}}</span>
                  <span>/ 500</span>
                </p>
              </div>
            </el-form-item>
            <!-- 上传照片 -->
            <el-form-item :label="$t('taskCenter.label.abovefile')"
                          label-width="140px"
                          prop="FileInfos">
              <file-upload ref="fileUpload"></file-upload>
            </el-form-item>
            <el-form-item>
              <div class="btnStyle">
                <el-button type="primary"
                           @click="taskAssignSubmit"
                           v-auth="'task:update'||'task:add'"
                           v-status>{{$t('taskCenter.button.assign')}}</el-button>
                <el-button @click="taskReviewCancle()">{{$t('taskCenter.button.cancel')}}</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- <el-dialog
      :title="$t('taskCenter.label.chooseArea')"
      :visible.sync="isVisArea"
      style="heigth:400px;"
      :close-on-click-modal="false"
    >
      <app-area-tree ref="areaTree" @closeTree="closeTree" @change="change"></app-area-tree>
    </el-dialog> -->
    <app-area-tree ref="areaTree"
                   @saveChecked="saveChecked" />
    <!-- 引入gis地图 -->
    <el-dialog :title="$t('taskCenter.label.mapChoice')"
               :visible.sync="isVisMap"
               v-dialogDrag
               style="heigth:400px;"
               @close="mapClose"
               @click="mapCancleOpt"
               append-to-body>
      <div id="task-mini-map"
           v-if="isVisMap"></div>
      <!-- 底部操作按钮 -->
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="mapConfirmOpt">{{$t('taskCenter.button.conform')}}</el-button>
        <el-button @click="mapCancleOpt">{{$t('taskCenter.button.cancel')}}</el-button>
      </span>
      <!-- 右方绘制按钮 -->
      <!-- <el-button plain @click="drawOpt" class="draw-btn">{{$t('taskCenter.button.frame')}}</el-button> -->
    </el-dialog>
  </div>
</template>
<script>
import { Dates, Cache, Dic, Validate } from '$utils'
import { API } from '../api'
// import AppAreaTree from "./AreaTree";
import AppAreaTree from '@src/components/business/app-area-tree'
import FileUpload from "./FileUpload";
import appAccountGroup from '@src/components/business/app-account-group'
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";
export default {
  components: {
    AppAreaTree,
    FileUpload,
    // appAccountGroup,
    workGroupTree
  },
  props: {
    onlyHandAlarm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validateTaskName = (rule, value, callback) => {
      if (!Validate.validateSpecialCharacters(value)) {
        callback(new Error(this.$t('taskCenter.message.taskNameWoed')))
      } else if (value.length < 4 || value.length > 50) {
        callback(new Error(this.$t('taskCenter.message.enterLen')))
      } else {
        callback();
      }
    }
    const validateDeviceName = (rule, value, callback) => {
      if (value.length < 8 || value.length > 30) {
        callback(new Error(this.$t('taskCenter.message.deviceInfoLen')))
      } else {
        callback();
      }
    }
    return {
      // 框选的人员数组
      selectedPersonnelArr: [],
      dialogImageUrl: '',
      // 区域是否显示-默认隐藏
      isVisArea: false,
      // 地图是否显示-默认隐藏
      isVisMap: false,
      fileInfos: [],
      // 照片数据
      // 人员分组数据
      executeTeams: [{
        executor: [],
        executorName: []
      }],
      groupData: [],
      accoutInfo: [],
      taskReViewStatus: false,
      isEquipmentAlarm: false,
      // 任务信息
      taskInfo: {
        taskName: '',
        taskPriority: 3,
        taskVisibility: 1,
        requiredStartTimeProp: '',
        taskType: 0,
        groupName: '',
        groupCode: '',
        desc: '',
        code: '',
        userFrom: '',
        executeTeams: []
      },
      // 任务描述信息总数
      taskDescTotal: 0,
      //   设备告警
      equipmentAlarmForm: {
        deviceName: '',
        alarmLevel: null,
        alarmType: null,
        subSystem: null,
        alarmTimeProp: ''
      },
      // 校验
      equipmentAlarmRules: {
        deviceName: [
          { required: true, message: this.$t('taskCenter.message.chooseName'), trigger: 'blur' },
          { validator: validateDeviceName, trigger: 'blur' }
        ],
        alarmLevel: [
          { required: true, message: this.$t('taskCenter.message.chooseAlarmLevel'), trigger: 'change' }
        ],
        alarmType: [
          { required: true, message: this.$t('taskCenter.message.chooseAlarm'), trigger: 'change' }
        ],
        subSystem: [
          { required: true, message: this.$t('taskCenter.message.chooseAlarm'), trigger: 'change' }
        ],
        alarmTimeProp: [
          { required: true, message: this.$t('taskCenter.message.chooseStart'), trigger: 'blur' }
        ]
      },
      option: {
        menuBtn: false,
        column: [
          {
            label: this.$t('taskCenter.label.taskNames'),
            prop: 'taskName',
            span: 20,
            clearable: true,
            row: true,
            rules: [
              { required: true, message: this.$t('taskCenter.placeholder.taskName'), trigger: 'blur' },
              { validator: validateTaskName, trigger: 'blur' }
            ],
            labelWidth: 140,
          },
          {
            label: this.$t('taskCenter.label.priority'),
            prop: 'taskPriority',
            type: 'select',
            labelWidth: 140,
            dicData: Dic.find('SENU008'),
            rules: [
              { required: true, message: this.$t('taskCenter.message.choosePriority'), trigger: 'change' },
            ],
            span: 10,
            clearable: true
          },
          {
            label: this.$t('taskCenter.label.taskVisibilitys'),
            prop: 'taskVisibility',
            type: 'select',
            labelWidth: 140,
            defaultIndex: 0,
            rules: [
              { required: true, message: this.$t('taskCenter.message.chooseVisibilitys'), trigger: 'change' },
            ],
            dicData: Dic.find('SENU009'),
            span: 10,
            clearable: true,
            row: true
          },
          {
            label: this.$t('taskCenter.label.requiredStartTimeProp'),
            prop: 'requiredStartTimeProp',
            type: 'datetime',
            valueFormat: 'timestamp',
            disabled: false,
            span: 20,
            clearable: true,
            labelWidth: 140,
            row: true,
            rules: [
              { required: true, message: this.$t('taskCenter.message.chooseTime'), trigger: 'blur' }
            ],
          },
          {
            label: this.$t('taskCenter.label.taskType'),
            prop: 'taskType',
            type: 'radio',
            labelWidth: 140,
            dicData: this.onlyHandAlarm ? [Dic.find('SENU010')[0]] : Dic.find('SENU010'),
            span: 20,
            clearable: true,
            row: true,
            rules: [
              { required: true, message: this.$t('taskCenter.message.chooseType'), trigger: 'blur' }
            ],
            change: ({ value, column, row }) => {
              let a = { value, column, row }
              if (a.value == 2) {
                this.isEquipmentAlarm = true;
                this.option.column[3].disabled = true;
                this.option.column[3].rules = [];
                this.taskInfo.requiredStartTimeProp = '';
              } else {
                this.isEquipmentAlarm = false;
                this.option.column[3].disabled = false;
                this.option.column[3].rules = [
                  { required: true, message: this.$t('taskCenter.message.chooseTime'), trigger: 'blur' }
                ];
              }
            }
          }
        ],
        submitText: this.$t('taskCenter.button.search'),
        labelPosition: 'right',
        submitPosition: 'center'
      },
      //   告警类型
      equipmentTypeOptions: Dic.find('SENU004'),
      //   告警级别
      alarmLevelOption: Dic.find('SENU017'),
      // 当前选择分组编号
      groupCode: '',
      isEdit: false,
      subTaskInfoList: [],
      // 地图详情数据
      mapDetailData: [],
      mapGis: null,
      drawObj: null,
      iconObj: null,
      drawPoint: []
    }
  },
  computed: {
    alarmTypeOption () {
      if (this.equipmentAlarmForm.subSystem) {
        return Dic.find('SENU004', { relation: this.equipmentAlarmForm.subSystem })
      } else {
        return [];
      }
    },
    taskName () {
      return this.taskInfo.taskName
    },
    igisMap () {
      return this.$refs['igis']
    }
  },
  watch: {
    // 去空格
    taskName (newValue, oldValue) {
      this.$nextTick(() => {
        this.$set(this.taskInfo, 'taskName', newValue.replace(/\s+/g, ""));
      });
    },

    // 监听任务描述信息输入的长度
    'taskInfo.desc': {
      handler (newName, oldName) {
        this.taskDescTotal = newName.length
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 挂载地图
    mapInit () {
      // const self = this;
      // self.mapGis = self.$refs.igis.map;
      // self.mapGis.setMapZoom(16);
      // console.log(self.mapGis,'********')
    },
    // 子系统选择改变
    subSystemChange () {
      this.equipmentAlarmForm.alarmType = this.alarmTypeOption[0].value;
    },
    // 选择区域且选择从分组选择
    checkByGroup () {
      if (this.taskInfo.userFrom === '0' && this.taskInfo.groupCode) {
        // this.$refs.appAcountGroup.groupCode = this.taskInfo.groupCode;
        // this.$refs.appAcountGroup.queryAccoutGroup();
      }
    },
    // 选择区域且从地图选择
    checkByMap () {
      console.log('=====地图')
      this.drawPoint = [];
      // 每次打开地图选择框前，将框选的人员置空
      this.accoutInfo = [];
      this.selectedPersonnelArr = [];
      this.isVisMap = true;
      this.$nextTick(() => {
        this.mapInit();
        this.mapCreateIconLayer(this.queryMapResource);
      })
    },
    // 查询地图数据
    queryMapResource () {
      let self = this;
      console.log('==============self.taskInfo',self.taskInfo)
      this.$map.MapInstance2D.resetMapStyle('task-mini-map');
      const params = {
        areaList: [self.taskInfo.groupCode],
        buildingId: '',
        // coordinateList: self.extent || [],
        // 获取地图的临界点
        // coordinateList: self.mapGis.getMapExtent() || [],
        floorId: '',
        isIndoor: '0',
        resourceName: '',
        resourceTypeList: ['999']
      };
      this.$fetch(API.bms.queryResource, params).then((res) => {
        if (res.success) {
          let pointsData = res.returnObj || [];
          self.resoucesList = res.returnObj;
          self.deviceList = res.returnObj;
          self.drawPoint = [];
          pointsData.forEach(item => {
            item.resourceList.map(subItem => {
              self.drawPoint.push({
                id: subItem.resourceId,
                src: 'images/map/resource/security_person_gray.png',
                label: subItem.resourceName,
                thirdDeviceId: subItem.thirdDeviceId,
                coord: [subItem.longitude, subItem.latitude]
              })
            })
          });
          // self.iconObj && self.iconObj.refreshLayerByData();
        } else {
          self.drawPoint = [];
          // self.iconObj && self.iconObj.refreshLayerByData();
        }
      })
    },
    // 绘制图形操作
    drawOpt () {
      // let self = this;
      // self.drawObj = new window.iGis.maptools.DrawFeature({
      //   gisMapObj: self.mapGis // mymap是地图对象
      // });
      // self.mapGis.addBoxSelection({
      //   layerObj: self.iconObj,
      //   endFunc: function (e) {
      //     // 重置摄像机数组
      //     self.mapGis.removeBoxSelection();
      //     self.selectedPersonnelArr = [];
      //     for (let item of e.map(k => k.get('property'))) {
      //       self.selectedPersonnelArr.push(item.label)
      //     }
      //     // 替换框选后保卫人员的图片
      //     if (e && e.length) {
      //       e.map(selectItem => {
      //         self.drawPoint.findIndex(pointItem => {
      //           if (selectItem.id_ == pointItem.id) {
      //             pointItem.src = 'images/map/resource/security_person.png';
      //           }
      //         })
      //       })
      //       self.iconObj && self.iconObj.refreshLayerByData();
      //     }

      //     if (self.selectedPersonnelArr.length <= 0) {
      //       self.$message({
      //         message: this.$t('taskCenter.message.choosePersons'),
      //         type: 'warning'
      //       });
      //     }
      //   }
      // });
    },

    // 点击gis地图框中的确定操作
    mapConfirmOpt () {
      let self = this;
      self.accoutInfo = [];
      self.isVisMap = false;
      if (self.selectedPersonnelArr == []) { return }
      self.selectedPersonnelArr.map(function (item) {
        self.accoutInfo.push({ executor: item, executorName: item, userFrom: 1 })
      })
      self.drawPoint = [];
      // 需清空地图上的标志信息
      // self.iconObj && self.iconObj.refreshLayerByData();
      self.drawObj = null;
      self.iconObj = null;
      self.mapGis = null
      self.$map.hideMap2D()
    },

    // 点击gis地图框中的取消操作
    mapCancleOpt () {
      let self = this;
      self.isVisMap = false;
      self.accoutInfo = [];
      self.mapDetailData = [];
      self.drawPoint = [];
      self.selectedPersonnelArr = [];
      // 需清空地图上的标志信息
      // self.iconObj && self.iconObj.refreshLayerByData();
      self.drawObj = null;
      self.iconObj = null;
      self.mapGis = null
      self.$map.hideMap2D()
    },

    mapCreateIconLayer (callback) {
      // const _self = this;
      // if (_self.mapGis == null) {
      //   this.$nextTick(() => {
      //     this.mapInit()
      //   })
      // }
      // _self.iconObj = new window.iGis.layers.IconLayer({
      //     gisMapObj: _self.mapGis,
      //     isRef: true,
      //     callBackFun: function (param) {
      //       param.currObj.setData(_self.drawPoint, param.seq)
      //     }
      // })  
      // callback && callback();            
      this.$map.showMap2D(callback);
      this.$map.MapInstance2D.rectangle(this.rectangleCB)
    },

    rectangleCB (event) {
      this.$log.debug('taskAssign==>', event);
    },

    // 选择区域树-回填数据
    saveChecked (val) {
      if (val && val.length) {
        this.taskInfo.areaDevGroupName = val[0].areaDevGroupName;
        this.taskInfo.groupCode = val[0].areaDevGroupCode;
      }
      this.checkByGroup();
      // this.closeTree();
    },
    closeTree () {
      this.isVisArea = false;
    },
    // 选择区域树
    openAreaTree () {
      // this.isVisArea = true;
      this.$nextTick(() => {
        if (this.taskInfo.areaDevGroupName) {
          this.$refs['areaTree'].openDialog([this.taskInfo.groupCode])
          // this.$refs.areaTree.setTreeData([this.taskInfo.groupCode]);
        } else {
          this.$refs['areaTree'].openDialog()
          // this.$refs.areaTree.setTreeData([]);
        }
      });
    },
    // 指派按钮(1:修改,0:保存)
    taskAssignSubmit () {
      // 验证通过
      const self = this;
      if (self.taskDescTotal > 500) {
        self.$message.error(this.$t('taskCenter.message.taskLength'));
        return
      }
      self.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          return;
        }
        if (!self.validateRequiretime()) {
          return;
        }
        self.taskInfo.taskAlarmWeb = self.equipmentAlarmForm;
        self.taskInfo.executeTeams = self.executeTeams;
        self.taskInfo.fileInfos = self.$refs.fileUpload.currentFileList;
        // 设备告警
        if (self.equipmentAlarmForm.alarmTimeProp) {
          self.equipmentAlarmForm.alarmTime = Dates.format(self.equipmentAlarmForm.alarmTimeProp, 'yyyy-MM-dd HH:mm:ss')
        }
        // 要求开始时间
        self.taskInfo.requiredStartTime = Dates.format(self.taskInfo.requiredStartTimeProp, 'yyyy-MM-dd HH:mm:ss')
        if (self.taskInfo.areaDevGroupName.length === 0) {
          self.$message({
            message: this.$t('taskCenter.message.chooseArea'),
            type: 'error'
          })
          return;
        }
        // 获取用户
        let hasAccount = false;
        if (self.taskInfo.userFrom === '0') { // 表示从分组选择执行人员
          // self.taskInfo.executeTeams = self.$refs.appAcountGroup.executeTeams || [];
          self.taskInfo.executeTeams = JSON.parse(JSON.stringify(self.executeTeams))
          self.taskInfo.executeTeams.map(item => {
            if (item.executorName.length > 0) {
              hasAccount = true;
            }
          });
        } else {
          if (self.accoutInfo.length > 0) { // 表示从地图选择执行人员
            self.taskInfo.executeTeams = [];
            let obj = { accountGroupCode: '', accountGroupName: '', executor: [], executorName: [], userFrom: 1 }
            self.accoutInfo.map(function (item) {
              obj.executor.push(item.executor);
              obj.executorName.push(item.executor);

            })
            self.taskInfo.executeTeams.push(obj);
            hasAccount = true;
          }
        }
        // console.log(self.taskInfo)
        // console.log(hasAccount)
        if (self.taskInfo.taskType == 2) {
          // 设备告警
          self.$refs['equipmentAlarmForm'].validate((valid1) => {
            if (!valid1) {
              return;
            }
            if (hasAccount) {
              self.$emit('childByValue', self.taskInfo);
            } else {
              console.log("ffffffffffffff", self.taskInfo.executeTeams)
              this.$message({
                message: this.$t('taskCenter.message.choosePerson'),
                type: 'error'
              })
            }
          });
        } else {
          if (hasAccount) {
            this.$emit('childByValue', self.taskInfo);
          } else {
            console.log("wwwwwwwwwww", self.taskInfo.executeTeams)
            self.$message({
              message: this.$t('taskCenter.message.choosePerson'),
              type: 'error'
            })
          }
        }
      });
    },
    validateRequiretime () {
      // 不是设备告警才需要验证时间
      if (this.taskInfo.taskType == 2) {
        return true;
      }
      if (!this.taskInfo.requiredStartTimeProp) {
        this.$message({
          message: this.$t('taskCenter.message.enterStart'),
          type: 'error'
        })
        return false;
      } else if (this.taskInfo.requiredStartTimeProp - (new Date).getTime() <= 0) {
        this.$message({
          message: this.$t('taskCenter.message.startEnd'),
          type: 'error'
        })
        return false;
      }
      return true;
    },
    taskReviewCancle (formName) {
      this.clearData();
      // 清空所有校验结果
      this.$refs['ruleForm'] && this.$refs['ruleForm'].clearValidate();
      // 默认情况下不显示当前表单
      this.$refs['equipmentAlarmForm'] && this.$refs['equipmentAlarmForm'].resetFields();
      this.$refs['taskArea'] && this.$refs['taskArea'].resetFields();
      this.taskReViewStatus = false;
    },
    // 处理执行人员数据
    handlePersonData (dataParam) {
      let self = this;
      if (dataParam.length > 0) {
        dataParam.map(item => {
          self.accoutInfo.push({
            executor: item.executor,
            executorName: item.executor,
            userFrom: 1
          })
        })
      }
    },
    editDataDeal (taskModInfo) {
      this.isEdit = true;
      this.option.column[3].rules = [
        { required: true, message: '请选择时间', trigger: 'blur' }
      ];
      this.taskInfo = taskModInfo.taskInfo;
      this.taskInfo.createTime = Dates.format(this.taskInfo.createTime, 'yyyy-MM-dd HH:mm:ss')
      if (taskModInfo.taskAlarmInfo && taskModInfo.taskAlarmInfo.subSystem) {
        this.equipmentAlarmForm = taskModInfo.taskAlarmInfo;
        // 转为int类型才能正确回填
        this.equipmentAlarmForm.alarmType = parseInt(this.equipmentAlarmForm.alarmType);
        this.equipmentAlarmForm.subSystem = parseInt(this.equipmentAlarmForm.subSystem);
        this.equipmentAlarmForm.alarmTimeProp = new Date(this.equipmentAlarmForm.alarmTime).getTime();
      }
      // 执行人员单选按钮进行回填 
      this.taskInfo.userFrom = taskModInfo.taskInfo.userFrom + '';

      // 人员组数据回填
      this.subTaskInfoList = taskModInfo.subTaskInfoList;
      if (this.taskInfo.userFrom == 1) {
        this.mapDetailData = taskModInfo.subTaskInfoList;
        this.$nextTick(function () {
          this.handlePersonData(this.mapDetailData);
        })
      }
      this.taskInfo.requiredStartTimeProp = this.taskInfo.requiredStartTime;

      if (this.taskInfo.taskType == 2) {
        this.isEquipmentAlarm = true;
      } else {
        this.isEquipmentAlarm = false;
      }
      this.$nextTick(() => {
        this.fileBackFill(taskModInfo.fileInfoList);
        // this.$refs.appAcountGroup.groupCode = this.taskInfo.groupCode;
        // this.$refs.appAcountGroup.dealData();
      });
    },
    open (taskModInfo) {
      this.taskReViewStatus = true;
      if (taskModInfo) {
        this.editDataDeal(taskModInfo);
      } else {
        this.$nextTick(() => {
          this.option.column[3].rules = [
            { required: true, message: '请选择时间', trigger: 'blur' }
          ];
          this.clearData();
          this.$refs['ruleForm'] && this.$refs['ruleForm'].clearValidate();
          // 默认情况下不显示当前表单
          this.$refs['equipmentAlarmForm'] && this.$refs['equipmentAlarmForm'].resetFields();
          this.$refs['taskArea'] && this.$refs['taskArea'].resetFields();
          // 清空图片
          this.fileBackFill([]);
          // 数据清空
          this.$refs.appAcountGroup.dealData();
        });
      }
    },
    // 删除执行人员信息
    deleteAccount (index) {
      this.accoutInfo.splice(index, 1);
    },
    // 图片回填
    fileBackFill (fileList) {
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.currentFileList = fileList;
        let imgCount = 0;
        let videoCount = 0;
        fileList.map(item => {
          switch (item.fileType) {
            case 0: imgCount++; break;
            case 1: videoCount++; break;
          }
        });
        this.$refs.fileUpload.fileFormat[0].currentCount = imgCount;
        this.$refs.fileUpload.fileFormat[1].currentCount = videoCount;
      }
    },
    mapClose () {
      this.$map.hideMap2D();
    },
    close () {
      this.clearData();
      this.taskReViewStatus = false;
    },
    clearData () {
      // 重置列表
      this.taskInfo = {
        fileInfos: [],
        taskName: '',
        taskPriority: 3,
        taskVisibility: 1,
        requiredStartTimeProp: '',
        taskType: 0,
        groupName: '',
        groupCode: '',
        desc: '',
        code: '',
        userFrom: '',
        areaDevGroupName: ''
      }
      // 清除执行人员
      this.subTaskInfoList = [];
      this.accoutInfo = [];
      this.isEquipmentAlarm = false;
      this.equipmentAlarmForm = {
        deviceName: '',
        alarmLevel: '',
        alarmType: '',
        subSystem: '',
        alarmTimeProp: ''
      }
      this.fileInfos = [];
      this.executeTeams = [{
        executor: [],
        executorName: []
      }];
      this.groupCode = '';
      this.groupData = [];
      this.option.column[3].disabled = false;
      this.$map.hideMap2D()
      // 清空图片
      if (this.$refs.fileUpload) {
        this.fileBackFill([]);
      }
    },
    getGroupData (data) {
      this.$log.debug('勾选', data);
      // console.log(this.executeTeams)
      // console.log(data)
      this.executeTeams[0].executor = data.map(item => {
        return item.id
      });
      this.executeTeams[0].executorName = data.map(item => {
        return item.name
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.area-container {
  .el-scrollbar__wrap {
    height: 150px !important;
  }
}
.wholePage {
  margin-top: -20px;
}
.equipmentAlarm {
  width: calc(87% - (-90px));
  margin-bottom: 10px;
  // border-radius: 4px;
  // border: 1px solid #323942;
  padding: 10px;
}
.page-bottom {
  margin-left: 10px;
}
.dialog-footer {
  margin-top: -20px;
}
.el-input__inner {
  width: 254px !important;
}
.panel {
  background-color: #355486;
  border-color: #596f94;
  overflow: auto;
  height: 180px;
  width: 160px;
}
.task-assign-component {
  .ioc-form__row:nth-child(5) {
    color: red;
  }
  .upload-img-item {
    display: inline-block;
    margin-right: 10px;
    .el-upload--picture-card,
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 80px;
      background-color: #355486;
    }
    .el-upload-list__item {
      width: 80px;
      height: 80px;
      line-height: 80px;
    }
  }
  .task-desc {
    width: 695px;
  }
  .task-desc-limit {
    position: relative;
    .span {
      position: absolute;
      bottom: -4px;
      right: 20px;
      color: #999;
      font-size: 14px;
    }
  }
  #task-mini-map {
    height: 450px;
  }
}
.draw-btn {
  position: absolute;
  top: 10%;
  right: 25px;
  background: #365977;
}
.clear-btn {
  position: absolute;
  top: 30%;
  right: 25px;
  background: #365977;
}
/*.btnStyle {*/
/*margin-left: 75%*/
/*}*/

.btnStyle {
  text-align: center;
}
.selectPerson {
  display: flex;
  color: #0086ff;
  position: absolute;
  right: 435px;
  top: 4px;
  cursor: pointer;
}
.expand {
  transform: rotate(90deg);
}
</style>

